import classes from "./Stage7.module.css";
import shared from "../Shared/shared.module.css";
import ReviewCard from "./ReviewCard";
import { IconChevronsLeft, IconArrowRight } from "@tabler/icons-react";
import { useNavigate } from "react-router";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../../context";
import { talentProfile } from "../../../services/talentCalls";
import { errorHandler } from "../../../utils";
import FullScreenLoader from "../../../components/Loaders/FullScreen/loader";

const TalentStage7 = () => {
  let { data, setData } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  let navigate = useNavigate();

  const fetchProfile = async () => {
    setLoading(true)
    try {
      const res = await talentProfile();

      setData(res?.data?.data?.talent);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      error?.response?.data
        ? errorHandler(error?.response?.data?.errors, "Error")
        : errorHandler(
            "Network error: Something went wrong, Please check your internet connection and try again.",
            "Error"
          );
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    fetchProfile();
  }, []);

  return (
    <div className={classes.main}>
      {loading && <FullScreenLoader />}
      <h2 className="center mb-md">Profile Review</h2>
      <ReviewCard data={data} />
      <div className={shared.panelFooter}>
        <button type="button" className={shared.btnBack} onClick={() => navigate(-1)}>
          <IconChevronsLeft size={16} /> Back
        </button>
        <div className={shared.footerActions}>
          <button
            type="button"
            className={shared.btnPrimary}
            onClick={() =>
              navigate({
                pathname: "/talent-onboarding",
                search: "stage=8",
              })
            }
          >
            Ok, look's great <IconArrowRight size={15} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default TalentStage7;
